import { render, staticRenderFns } from "./StockIn.vue?vue&type=template&id=670a0201&scoped=true"
import script from "./StockIn.vue?vue&type=script&lang=js"
export * from "./StockIn.vue?vue&type=script&lang=js"
import style0 from "./StockIn.vue?vue&type=style&index=0&id=670a0201&prod&scoped=true&lang=css"
import style1 from "./StockIn.vue?vue&type=style&index=1&id=670a0201&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a0201",
  null
  
)

export default component.exports